<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getOuMilestoneList_data.mtName"
          placeholder="请输入里程碑名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getOuMilestoneList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button v-if="addOuMilestone"
          @click=" $form('addOuMilestone') "
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加里程碑
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getOuMilestoneList'
      api='getOuMilestoneList'
      updateapi='updateOuMilestone'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addOuMilestone:    [ "新增里程碑信息", "el-icon-circle-plus" ],
        updateOuMilestone: [ "修改里程碑信息", "el-icon-edit-outline"],
        $succeed$: getOuMilestoneList
      }'
      @close='$form("addOuMilestone","reset")' >
      <!-- <hide slot='mtId' /> -->
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mtId: null,

      tableColums_getOuMilestoneList: {
        $selection: false,

        mtName: '里程碑名称',

        mtRemark: '描述',

        $operation: [
          '操作', 200,
          this.updateOuMilestone && `@text: 编辑#success
           @click: $form("updateOuMilestone",$row)
          `,
          this.deleteOuMilestone && `@text: 删除#danger
           @click: _confirm('确定要删除该里程碑吗?')
                   .trigger('deleteOuMilestone',{mtId:$row.mtId})
                   .trigger('getOuMilestoneList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getOuMilestoneList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bussiness/MilestoneManage.vue